var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('div',{staticClass:"flex items-center justify-center gap-x-2"},_vm._l(([1, 2, 3, 4]),function(item){return _c('span',{key:item,staticClass:"h-2.5 w-2.5 animate-spinner-dots rounded-full bg-azure",class:_setup.delays[item]})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }